'use client'

import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'

import { trackClickLinkFaq } from '@/utils/tracker/modules/common'

import { ContainerNoPadding } from '@/components/Container'

import { FAQ_LINKS } from '@/configs/constants'

export function FaqSection() {
  return (
    <div className="z-0 bg-gray-5">
      <ContainerNoPadding className="-mt-96 pb-4 pt-96 md:-mt-56 md:pt-56 lg:-mt-40 lg:pt-40">
        <Text className="px-4 pt-4 md:px-0">
          Akses terhadap data platform prioritas ini bersifat terbatas. Untuk
          informasi lebih lanjut dapat di akses melalui halaman berikut{' '}
          <Text as="span" className="inline-flex items-center gap-1">
            <Link
              underline={false}
              className="font-bold"
              href={`${FAQ_LINKS.COMMON}?utm_source=portal-satu-data`}
              rel="noopener noreferrer"
              target="_blank"
              onClick={() => {
                trackClickLinkFaq({
                  gaEventName: 'prioritas',
                  pageTitle: 'Platform Prioritas',
                })
              }}
            >
              FAQ{' '}
            </Link>
            <Icon fontSize="sm" className="hover:no-underline">
              help
            </Icon>
          </Text>
        </Text>
      </ContainerNoPadding>
    </div>
  )
}
